import { Box, Card, Icon, Divider, Typography } from "@mui/material";
import { ENUM_CURRENCY, RENDERER_TYPES } from "../../../enums";
import {
  getPercentageIncreaseOrDescrease,
  numberFormat,
} from "../../../services/utils";

function SummaryItem({ item }) {
  const handleRenderer = () => {
    switch (item.rendererType) {
      case RENDERER_TYPES.AMOUNT:
        return numberFormat(item.currentMonth, ENUM_CURRENCY.USD);

      default:
        return numberFormat(item.currentMonth);
    }
  };

  return (
    <Card
      component={"fieldset"}
      elevation={2}
      sx={{ border: 0, height: 134}}
    >
      <legend>
        <Box
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          bgcolor="#070639"
          height="50px"
          width="50px"
          borderRadius="10px"
        >
          <Icon className="white-color">{item.icon}</Icon>
        </Box>
      </legend>

      <Box mt={-1} mb={1} textAlign="right">
        <Typography fontSize={12} fontWeight={500} color="#000000">
          {item.label}
        </Typography>
        <Typography
          fontSize={16}
          fontWeight={500}
          color={item?.currentMonth > item?.lastCount ? "#41C197" : "#F65C8D"}
        >
          {handleRenderer()}
        </Typography>
      </Box>

      <Box component={"div"}>
        <Divider className="divider-border" />
        <Box display={"flex"}>
          <Typography
            fontSize={12}
            fontWeight={500}
            color={item?.currentMonth > item?.lastCount ? "#41C197" : "#F65C8D"}
            pt={1}
            mr={0.5}
          >
            {`${getPercentageIncreaseOrDescrease(
              item?.currentMonth,
              item?.lastCount
            )}%`}
          </Typography>
          <Typography
            fontSize={12}
            fontWeight={500}
            pt={1}
            color="#000000"
          >
            than last Month
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}

export { SummaryItem };
